/// <reference types="cordova-plugin-device"/>
/// <reference types="cordova-plugin-file"/>
/// <reference types="cordova-plugin-inappbrowser"/>

import { Attachment } from './attachment.model';
import { Item } from './item.model';
import { environment } from 'src/environments/environment.cordova';
import { SimpleModal } from '../templates';
import { ModalSize } from 'ng2-semantic-ui';
import { resolve } from 'url';
import { element } from 'protractor';
import { Router } from '@angular/router';
import { Word } from './word.model';
import { MapCacheData } from './mapcache';

declare var cordova;

interface CordovaPlugins {
    notification: any;
}

// il path della cartella dove sono collocati i file dell'esperienza salvata sara:
// cordova.file.dataDirectory + id_esperienza + nome_tappa + id_item

const PATH_FILE = 'temp';
const PATH_MAPS = 'maps/';
const MAP_NAME = 'wms.zip';
/**
 * Salva in un detterminato file e posizione il blob passatto alla funzione
 * @param blob il blob del file da salvare
 * @param fileName nome del file in cui salvare
 * @param device tipo di dispositivo su cui viene chiamata la funzione
 * @returns {Promise} ritorna la promise a funzione completata o fallita
 */
export function saveBlobToFile(blob, fileName, device): Promise<any> {
    return new Promise((resolve, reject) => {
        let folder: string = '';
        const dir: string = 'Downloads'
        if (device == 'Android') {
            folder = cordova.file.externalDataDirectory;
        } else {
            folder = cordova.file.documentsDirectory;
        }
        window.resolveLocalFileSystemURL(folder, function (fs: DirectoryEntry) {
            // console.log('file system open: ' + fs.name)
            fs.getDirectory(dir, { create: true, exclusive: false }, function (dirEntry) {
                dirEntry.getFile(fileName + '.txt', { create: true, exclusive: false }, function (fileEntry) {
                    fileEntry.createWriter(function (fileWriter) {
                        fileWriter.onwriteend = function () {
                            // console.log('Successful file write...');
                            cordova.plugins.notification.local.schedule({
                                title: fileName + '.txt',
                                text: 'Download completato!',
                                actions: [
                                    { id: 'open', title: 'Apri' }
                                ],
                                foreground: true,
                                priority: 1,
                            });
                            cordova.plugins.notification.local.on('open', (notification) => {
                                openFile(fileEntry.toURL());
                                cordova.plugins.notification.local.clearAll();
                            });
                            cordova.plugins.notification.local.on('click', (notification) => {
                                openFile(fileEntry.toURL());
                                cordova.plugins.notification.local.clearAll();
                            });
                            resolve(fileEntry.toURL());
                        };

                        fileWriter.onerror = function (e) {
                            console.log('Failed file write: ' + e.toString());
                            reject(e);
                        };
                        fileWriter.write(blob);
                    });
                }, (onErrorCreateFile) => {
                    console.log('errore creazione');
                    reject(onErrorCreateFile);
                });
            }, (onErrorLoadFs) => {
                console.log('errore caricamento')
                reject(onErrorLoadFs);
            });

        }, (onErrorLoadFs) => {
            console.log('errore caricamento')
            reject(onErrorLoadFs);
        });
    });
}
/**
 * Permette di scaricare e salvare in locale un file dal server
 * @param URL del file da scaricare
 * @param folderName la cartella in cui salvarlo
 * @param fileName nome finale del file da creare
 * @returns {Promise} ritorna la promise a funzione completata o fallita
 */
// export function downloadMobile(URL:string, folderName:string, fileName:string): Promise<{file: string, value: boolean|Error|ProgressEvent}> {
export function _downloadMobile(URL, folderName, fileName) {
    return new Promise((resolve, reject) => {
        console.log(folderName);
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (fs: DirectoryEntry) {
            console.log('file system open: ');
            const dirs = folderName.split('/').reverse();
            let root = fs;
            console.log(dirs);

            const createDir = function (dir) {
                console.log('create dir ' + dir);
                root.getDirectory(dir, {
                    create: true,
                    exclusive: false
                }, successCB, failCB);
            };

            const successCB = function (entry) {
                console.log('dir created ' + entry.fullPath);
                root = entry;
                if (dirs.length > 0) {
                    createDir(dirs.pop());
                } else {
                    console.log('all dir created');
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.open('GET', URL, true);

                    xhr.onload = function () {
                        if (this.status == 200) {
                            const blob = new Blob([this.response]);
                            entry.getFile(fileName.toString(), { create: true, exclusive: false }, function (fileEntry) {

                                fileEntry.createWriter(function (fileWriter) {
                                    fileWriter.onwriteend = function () {
                                        console.log('Successful file write...');
                                        resolve({ file: fileName, value: true });
                                    };

                                    fileWriter.onerror = function (e) {
                                        console.log('Failed file write: ' + e.toString());
                                        resolve({ file: fileName, value: e });
                                    };
                                    fileWriter.write(blob);
                                });

                            }, (onErrorCreateFile) => {
                                console.log(onErrorCreateFile);
                                resolve({ file: fileName, value: onErrorCreateFile });
                            });
                        }
                    };
                    xhr.onerror = function (e) {
                        console.log(e);
                        resolve({ file: fileName, value: e });
                    }
                    xhr.send();
                }
            };

            const failCB = function (dir) {
                console.log('failed to create dir ' + dir);
                resolve({ file: fileName, value: false });
            };

            createDir(dirs.pop());

        }, (onErrorLoadFs) => {
            console.log(onErrorLoadFs);
            resolve({ file: fileName, value: onErrorLoadFs });
        });
    });
}
export function downloadMobile(URL, folderName, fileName) {
    return new Promise((resolve, reject) => {
        console.log(folderName);
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (fs: DirectoryEntry) {
            // console.log('file system open: ');
            const dirs = folderName.split('/').reverse();
            let root = fs;
            // console.log(dirs);

            const createDir = function (dir) {
                // console.log('create dir ' + dir);
                root.getDirectory(dir, {
                    create: true,
                    exclusive: false
                }, successCB, failCB);
            };

            const successCB = function (entry) {
                // console.log('dir created ' + entry.fullPath);
                root = entry;
                if (dirs.length > 0) {
                    createDir(dirs.pop());
                } else {
                    console.log('all dir created');
                    cordova.plugin.http.downloadFile(URL, null, null, entry.toURL() + fileName, (entry) => {
                        // console.log('Successful file write...');
                        // console.log(entry.toURL());
                        resolve({ file: fileName, value: true });
                    }, (error) => {
                        console.log('Failed file write: ', error);
                        resolve({ file: fileName, value: error });
                    })
                    // const xhr = new XMLHttpRequest();
                    // xhr.responseType = 'blob';
                    // xhr.open('GET', URL, true);

                    // xhr.onload = function () {
                    //     if (this.status == 200) {
                    //         const blob = new Blob([this.response]);
                    //         entry.getFile(fileName.toString(), { create: true, exclusive: false }, function (fileEntry) {

                    //             fileEntry.createWriter(function (fileWriter) {
                    //                 fileWriter.onwriteend = function () {
                    //                     console.log('Successful file write...');
                    //                     resolve({ file: fileName, value: true });
                    //                 };

                    //                 fileWriter.onerror = function (e) {
                    //                     console.log('Failed file write: ' + e.toString());
                    //                     resolve({ file: fileName, value: e });
                    //                 };
                    //                 fileWriter.write(blob);
                    //             });

                    //         }, (onErrorCreateFile) => {
                    //             console.log(onErrorCreateFile);
                    //             resolve({ file: fileName, value: onErrorCreateFile });
                    //         });
                    //     }
                    // };
                    // xhr.onerror = function (e) {
                    //     console.log(e);
                    //     resolve({ file: fileName, value: e });
                    // }
                    // xhr.send();
                }
            };

            const failCB = function (dir) {
                console.log('failed to create dir ' + dir);
                resolve({ file: fileName, value: false });
            };

            createDir(dirs.pop());

        }, (onErrorLoadFs) => {
            console.log(onErrorLoadFs);
            resolve({ file: fileName, value: onErrorLoadFs });
        });
    });
}
/**
 * Creare delle subdictory
 * @param path di directory da creare
 * @param fileName file da creare alla file del path
 * @param URL indirizzo del file da scaricare
 *    /
function createDirectorys(path, fileName, URL) {
    const dirs = path.split('/').reverse();
    let root = window.FS;
    console.log(dirs);

    const createDir = function (dir) {
        console.log('create dir ' + dir);
        root.getDirectory(dir, {
            create: true,
            exclusive: false
        }, successCB, failCB);
    };

    const successCB = function (entry) {
        console.log('dir created ' + entry.fullPath);
        root = entry;
        if (dirs.length > 0) {
            createDir(dirs.pop());
        } else {
            console.log('all dir created');
            getSampleFile(entry, fileName, URL);
        }
    };

    const failCB = function (dir) {
        console.log('failed to create dir ' + dir);
    };

    createDir(dirs.pop());
}
*/
/**
 * Permette di scaricare un file
 * @param dirEntry cartella di destinazione
 * @param fileName file da creare
 * @param URL indirizzo del file da scaricare
 */
function getSampleFile(dirEntry, fileName, URL) {

    const xhr = new XMLHttpRequest();
    xhr.open('GET', URL, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
        if (this.status == 200) {
            const blob = new Blob([this.response]);
            saveFile(dirEntry, blob, fileName);
        }
    };
    xhr.send();
}
/**
 * Genera un file vuoto su cui scrivere
 * @param dirEntry cartella di destinazione
 * @param fileData dati da scrivere su file
 * @param fileName file su cui scrivere
 */
function saveFile(dirEntry, fileData, fileName) {

    dirEntry.getFile(fileName.toString(), { create: true, exclusive: false }, function (fileEntry) {

        writeFile(fileEntry, fileData);

    }, (onErrorCreateFile) => { console.log(onErrorCreateFile) });
}
/**
 * Creare un file vuoto o ne apre uno esistnte su cui scrivere
 * @param dirEntry cartella di destinazione
 * @param fileName file da creare se non esiste o aprire per la scrittura
 * @param blob file in formato blob da scrivere su filename
 */
function createFile(dirEntry, fileName, blob) {
    // Creates a new file
    dirEntry.getFile(fileName.toString(), { create: true, exclusive: false }, function (fileEntry) {
        writeFile(fileEntry, blob)
    }, (onErrorCreateFile) => { console.log('errore creazione') })
}
/**
 * Scrive su un file il blob passatogli
 * @param fileEntry file su cui scrivere
 * @param blob file in formato blob da cui prelecar i dati
 */
function writeFile(fileEntry, blob) {
    fileEntry.createWriter(function (fileWriter) {
        fileWriter.onwriteend = function () {
            console.log('Successful file write...');
            // per leggerli in test si può decomentare
            if (blob.type == 'image/jpg' || blob.type == 'image/jpeg' || blob.type == 'image/png') {
                readBinaryFile(fileEntry);
            }
            // else {
            //     readFile(fileEntry);
            // }
        };

        fileWriter.onerror = function (e) {
            console.log('Failed file write: ' + e.toString());
        };
        fileWriter.write(blob);
    });
}
/**
 * Elimina uno specifico file
 * @param dir cartella di destinazione
 * @param fileName nome del file da eliminare
 */
function removeFile(dir, fileName) {
    dir.getFile(fileName, { create: false }, function (fileEntry) {
        fileEntry.remove(function (file) {
            console.log('file removed!');
        }, function (error) {
            console.log('error occurred: ' + error.code);
        }, function () {
            console.log('file does not exist');
        });
    });
}
/**
 * Legge lo strem dei dati di uno specifico file
 * @param fileEntry nome del file da leggere
 */
function readFile(fileEntry) {

    fileEntry.file(function (file) {
        const reader = new FileReader();

        reader.onloadend = function () {
            console.log('Successful file read: ' + this.result);
        };

        reader.readAsText(file);

    }, (onErrorReadFile) => { console.log(onErrorReadFile) });
}
/**
 * Legge lo stream dei dati in formato binario
 * @param fileEntry nome del file da leggere
 */
function readBinaryFile(fileEntry) {

    fileEntry.file(function (file) {
        const reader = new FileReader();

        reader.onloadend = function () {

            console.log('Successful file write: ' + this.result);
        };

        reader.readAsArrayBuffer(file);

    }, (onErrorReadFile) => { console.log(onErrorReadFile) });
}
/**
 * Ritorna il path della cartella di sistema dedicata all'applicazione
 * @returns {string} path della cartella di sistema dedicata all'applicazione
 */
export function returnPathFolder(): DirectoryEntry | string {
    let myPath: DirectoryEntry | string = '';
    window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs: FileSystem) {
        myPath = fs.root;

    }, (onErrorLoadFs) => { console.log(onErrorLoadFs) });
    return myPath;
}
/**
 * Rimuove la cartella e tutto il suo contenuto in modo ricorsivo
 * @param folder nome della cartella da eliminare
 */
export function removeDirFolder(folder) {
    window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (fs: DirectoryEntry) {
        fs.getDirectory(folder, { create: true, exclusive: false }, function (entry) {
            entry.removeRecursively(function () {
                console.log('Remove Recursively Succeeded');
            }, (err) => { console.log('Errore remove dir: ' + err) });
        }, (err) => { console.log('Errore apertura fs remove dir: ' + err) });
    });
}
/**
 * Salva gli allegati dell'esperinza nella cartella dedicata
 * @param file l'allegato da salvare
 * @param fileName nome del file in cui scrivere l'allegato
 */
export function saveAttachmentInDir(file, fileName) {
    const blob = convertFileToBlob(file);
    const folder = cordova.file.dataDirectory;
    const dir = PATH_FILE;
    window.resolveLocalFileSystemURL(folder, function (dirEntry: DirectoryEntry) {
        dirEntry.getDirectory(dir, {
            create: true,
            exclusive: false
        }, (newDir) => {
            console.log('file system open: ' + dirEntry.name)
            createFile(newDir, fileName, blob);
        }, (failCB) => {
            console.log('errore saveAttachment newDir: ');
            console.log(failCB);
        });


    }, (onErrorLoadFs) => {
        console.log('errore caricamento: ');
        console.log(onErrorLoadFs);
    });
}
/**
 * Cancella un allegato dell'esperienza
 * @param fileName nome dell'allegato da cancellare
 */
export function deleteAttachmentFile(fileName) {
    const folder = cordova.file.dataDirectory;
    const dir = PATH_FILE;
    window.resolveLocalFileSystemURL(folder, function (dirEntry: DirectoryEntry) {
        dirEntry.getDirectory(dir, {
            create: true,
            exclusive: false
        }, (newDir) => {
            console.log('file system open: ' + dirEntry.name)
            removeFile(newDir, fileName);
        }, (failCB) => {
            console.log('errore saveAttachment newDir: ');
            console.log(failCB);
        });


    }, (onErrorLoadFs) => {
        console.log('errore caricamento: ');
        console.log(onErrorLoadFs);
    });
}
/**
 * Carica gli allegati dell'esperienza sul cloud
 * @param fileName nome del file dell'allegato in locale
 * @param {Item} item item a cui appartiene l'allegato
 * @param {FormData} formData oggetto da spedire al server
 * @param s3service servizio angula preposto al caricamento del formData
 * @returns {Promise} ritorna una promise
 */
export function uploadAttachmentFile(fileName, item: Item, formData: FormData, s3service): Promise<any> {
    return new Promise((resolve, reject) => {
        const folder = cordova.file.dataDirectory;
        const dir = PATH_FILE;
        const folderPath = folder + dir;
        window.resolveLocalFileSystemURL(folderPath, function (dir: DirectoryEntry) {
            dir.getFile(fileName.toString(), { create: false }, function (fileEntry: FileEntry) {
                fileEntry.file(function (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        // Create a blob based on the FileReader "result", which we asked to be retrieved as an ArrayBuffer
                        const blob = new Blob([new Uint8Array(reader.result as ArrayBuffer)], { type: file.type });
                        const myFile: any = blob
                        myFile.lastModifiedDate = new Date();
                        myFile.name = fileName;
                        console.log(myFile as File);
                        formData.append('file', myFile as File, fileName);

                        s3service.create(formData)
                            .subscribe(response => {
                                console.log('caricato');
                                resolve(true);
                            }, error => {
                                console.log('errore caricamento s3');
                                reject(error);
                            });
                    };
                    // Read the file as an ArrayBuffer
                    reader.readAsArrayBuffer(file);
                });
            });
        });
    });
}


function getDbDir(): Promise<DirectoryEntry> {
    let dbdir: Promise<DirectoryEntry>;
    if (device.platform === 'Android') {
        // Android default location: cordova.file.applicationStorageDirectory+"databases/your_database_name"
        dbdir = new Promise((fulfill, reject) => {
            window.resolveLocalFileSystemURL(
                cordova.file.applicationStorageDirectory,
                (fs: DirectoryEntry) => {
                    fs.getDirectory(
                        'databases',
                        { create: true, exclusive: false },
                        (databases: DirectoryEntry) => {
                            fulfill(databases);
                        },
                        (err: FileError) => { reject(err); }
                    );
                },
                (err: FileError) => { reject(err); }
            );
        });
    } else if (device.platform === 'iOS') {
        // IOS location (with location:1 parameter) cordova.file.documentsDirectory+"your_database_name"
        dbdir = new Promise((fulfill, reject) => {
            window.resolveLocalFileSystemURL(
                cordova.file.documentsDirectory,
                (fs: DirectoryEntry) => {
                    fulfill(fs);
                },
                (err: FileError) => { reject(err); }
            );
        });
    } else {
        dbdir = Promise.reject(new Error('Unknown host device'));
    }
    return dbdir;
}


/**
 * Scarica una mappa in locale
 * @param map oggetto mappa in cui è presente id, val(URL)
 * @returns {Promise}
 */
export function _downloadMap(map: Word, router: Router): Promise<boolean> {
    return new Promise<boolean>((fullfil, reject) => {

        getDbDir().then((de: DirectoryEntry) => {
            console.log('all dir created');
            const xhr = new XMLHttpRequest();
            xhr.open('GET', map.val, true);
            xhr.responseType = 'blob';
            cordova.plugins.notification.local.schedule({
                id: 3,
                title: 'Mappa: ' + map.cat,
                text: 'Sto scaricando...',
                foreground: true,
                priority: 1,
            });
            // xhr.onload = (thisreq: XMLHttpRequest, evt: ProgressEvent) => {
            xhr.onload = function (this: XMLHttpRequest, evt: ProgressEvent) {
                const thisreq = this;
                if (thisreq.status === 200) {
                    cordova.plugins.notification.local.schedule({
                        id: 3,
                        title: 'Mappa: ' + map.cat,
                        text: 'Salvataggio in corso...',
                        foreground: true,
                        priority: 1,
                    });
                    const blob = new Blob([thisreq.response], { type: 'application/x-sqlite3' });
                    console.log(blob);
                    de.getFile(
                        MapCacheData.mapname(map.id),
                        { create: true, exclusive: false },
                        (fileEntry) => {
                            fileEntry.createWriter((fileWriter: FileWriter) => {
                                fileWriter.onwriteend = () => {
                                    console.log('Successful file write...');
                                    alert('Successful file write...');
                                    fullfil(true);
                                };

                                fileWriter.onprogress = () => { console.log(thisreq); };

                                fileWriter.onerror = (e) => {
                                    console.log('Failed file write: ' + e.toString());
                                    reject(false);
                                };

                                function gotFileWriter(writer: FileWriter) {
                                    function writeFinish() {
                                        console.log('Successful file write...');
                                        cordova.plugins.notification.local.schedule({
                                            id: 3,
                                            title: 'Mappa: ' + map.cat,
                                            text: 'Salvataggio mappa completato!',
                                            foreground: true,
                                            priority: 1,
                                            actions: [
                                                { id: 'open', title: 'Apri' }
                                            ],
                                        });
                                        cordova.plugins.notification.local.on('open', (notification) => {
                                            console.log(notification);
                                            if (notification.id === 3) {
                                                router.navigate(['maps']);
                                                cordova.plugins.notification.local.clearAll();
                                                cordova.plugins.notification.local.un('open');
                                            }
                                        });
                                        MapCacheData.registerId(map.id);
                                        fullfil(true);
                                    }

                                    let written = 0;
                                    const BLOCK_SIZE = 5 * 1024 * 1024; // prova con 5MB
                                    function writeNext(cbFinish) {
                                        writer.onwrite = (evt) => {
                                            if (written < blob.size) {
                                                writeNext(cbFinish);
                                            } else {
                                                writeFinish();
                                            }
                                        };
                                        writer.onwriteend = () => { };

                                        if (written) { writer.seek(writer.length); }
                                        writer.write(blob.slice(written, written + Math.min(BLOCK_SIZE, blob.size - written)));
                                        written += Math.min(BLOCK_SIZE, blob.size - written);
                                    }
                                    writeNext(writeFinish);
                                }
                                gotFileWriter(fileWriter);
                            });

                        }, (onErrorCreateFile) => {
                            console.log(onErrorCreateFile);
                            reject(false);
                        });
                } else {
                    reject(-1);
                }
                return null;
            };
            xhr.onerror = (reason) => { reject(reason); };
            xhr.send();
        }).catch((err) => { reject(err); });
    });
}

export function downloadMap(map: Word, url_map: string, router: Router): Promise<boolean> {
    return new Promise<boolean>((fullfil, reject) => {

        getDbDir().then((de: DirectoryEntry) => {
            console.log('all dir created');
            cordova.plugin.http.downloadFile(url_map, null, null, de.toURL() + MapCacheData.mapname(map.id), (entry) => {
                // prints the filename
                console.log(entry.name);

                // prints the filePath
                console.log(entry.fullPath);
                cordova.plugins.notification.local.schedule({
                    id: 3,
                    title: 'Mappa: ' + map.cat,
                    text: 'Salvataggio mappa completato!',
                    foreground: true,
                    priority: 1,
                    actions: [
                        { id: 'open', title: 'Apri' }
                    ],
                });
                cordova.plugins.notification.local.on('open', (notification) => {
                    console.log(notification);
                    if (notification.id === 3) {
                        router.navigate(['maps']);
                        cordova.plugins.notification.local.clearAll();
                        cordova.plugins.notification.local.un('open');
                    }
                });
                MapCacheData.registerId(map.id);
                fullfil(true);
            }, (response) => {
                console.error(response);
                let error = 'Status: ' + response.status + '\nMessagge: ' + response.error;
                reject(error);
            });
            
        }).catch((err) => { reject(err); });
    });
}

export function downloadMap_old(map: Word, router: Router): Promise<any> {
    const URL = map.val;

    const folderName = PATH_MAPS + map.id;
    const fileName = MAP_NAME;
    return new Promise((resolve, reject) => {
        console.log(folderName);
        // if cordova.d
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (fs: DirectoryEntry) {
            console.log('file system open: ');
            const dirs = folderName.split('/').reverse();
            let root = fs;
            console.log(dirs);

            const createDir = (dir: string) => {
                console.log('create dir ' + dir);
                root.getDirectory(dir, {
                    create: true,
                    exclusive: false
                }, successCB, failCB);
            };

            const successCB = function (entry) {
                console.log('dir created ' + entry.fullPath);
                root = entry;
                if (dirs.length > 0) {
                    createDir(dirs.pop());
                } else {
                    console.log('all dir created');
                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', URL, true);
                    xhr.responseType = 'blob';
                    // xhr.onreadystatechange = function() {
                    //     console.log(this);
                    // };
                    cordova.plugins.notification.local.schedule({
                        id: 3,
                        title: 'Mappa: ' + map.cat,
                        text: 'Sto scaricando...',
                        foreground: true,
                        priority: 1,
                    });

                    xhr.onload = function () {
                        if (this.status === 200) {
                            cordova.plugins.notification.local.schedule({
                                id: 3,
                                title: 'Mappa: ' + map.cat,
                                text: 'Salvataggio in corso...',
                                foreground: true,
                                priority: 1,
                            });
                            const blob = new Blob([this.response], { type: 'application/zip' });
                            console.log(blob);
                            entry.getFile(fileName.toString(), { create: true, exclusive: false }, function (fileEntry) {

                                fileEntry.createWriter(function (fileWriter) {
                                    fileWriter.onwriteend = function () {
                                        console.log('Successful file write...');
                                        alert('Successful file write...');
                                        resolve(true);
                                    };

                                    fileWriter.onprogress = function () {
                                        console.log(this);
                                    };

                                    fileWriter.onerror = function (e) {
                                        console.log('Failed file write: ' + e.toString());
                                        reject(false);
                                    };
                                    function gotFileWriter(writer) {
                                        function writeFinish() {
                                            console.log('Successful file write...');
                                            cordova.plugins.notification.local.schedule({
                                                id: 3,
                                                title: 'Mappa: ' + map.cat,
                                                text: 'Salvataggio mappa completato!',
                                                foreground: true,
                                                priority: 1,
                                                actions: [
                                                    { id: 'open', title: 'Apri' }
                                                ],
                                            });
                                            cordova.plugins.notification.local.on('open', (notification) => {
                                                console.log(notification);
                                                if (notification.id === 3) {
                                                    router.navigate(['maps']);
                                                    cordova.plugins.notification.local.clearAll();
                                                    cordova.plugins.notification.local.un('open');
                                                }
                                            });
                                            resolve(true);
                                        }

                                        let written = 0;
                                        const BLOCK_SIZE = 5 * 1024 * 1024; // prova con 5MB
                                        function writeNext(cbFinish) {
                                            writer.onwrite = function (evt) {
                                                if (written < blob.size) {
                                                    writeNext(cbFinish);
                                                } else {
                                                    writeFinish();
                                                }
                                            };
                                            writer.onwriteend = function () {
                                            };

                                            if (written) { writer.seek(writer.length); }
                                            writer.write(blob.slice(written, written + Math.min(BLOCK_SIZE, blob.size - written)));
                                            written += Math.min(BLOCK_SIZE, blob.size - written);
                                        }
                                        writeNext(writeFinish);
                                    }
                                    gotFileWriter(fileWriter);
                                    // fileWriter.write(blob);
                                });

                            }, (onErrorCreateFile) => {
                                console.log(onErrorCreateFile);
                                reject(false);
                            });
                        } else {
                            reject(-1);
                        }
                    };
                    xhr.onerror = function () {
                        reject(-1);
                    };
                    xhr.send();
                }
            };

            const failCB = function (dir) {
                console.log('failed to create dir ' + dir);
                reject(false);
            };

            createDir(dirs.pop());

        }, (onErrorLoadFs) => {
            console.log(onErrorLoadFs);
            reject(false);
        });
    });
}

/**
 * Cancella una mappa in base al suo id
 * @param id della mappa da cancellare
 * @returns {Promise}
 */
export function deleteMap(id) {
    return new Promise((fulfill, reject) => {
        getDbDir().then(
            (de: DirectoryEntry) => {
                de.getFile(MapCacheData.mapname(id),
                    { create: false, exclusive: false },
                    (fe: FileEntry) => {
                        fe.remove(
                            () => { fulfill(true); },
                            (err: FileError) => { reject('error removing file ' + err.code) }
                        );
                    },
                    (error: FileError) => { fulfill(true); }
                );
            }
        ).catch((err: any) => { reject(err); });
    });
}

export function deleteMap_old(id) {
    const folder = cordova.file.dataDirectory;
    const dir = PATH_MAPS;
    const fileName = MAP_NAME;
    return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(folder + dir, function (dirEntry: DirectoryEntry) {

            console.log('file system open: ' + dirEntry.name);
            dirEntry.getDirectory(id.toString(), { create: false }, function (mapEntry) {
                mapEntry.removeRecursively(() => {
                    console.log('dir removed!');
                    resolve(true);
                }, (error) => {
                    console.log('error occurred: ' + error.code);
                    reject(error.code);
                });
            });

        }, (onErrorLoadFs) => {
            console.log('errore caricamento: ');
            console.log(onErrorLoadFs);
            reject(false);
        });
    });
}
/**
 * Controlla se è presente in locale una detterminata mappa in base all'id
 * @param id della mappa da controllare
 * @returns {Promise} sempre positiva per non essere bloccante ma con un oggetto che nel campo value specifa se trovato o meno
 */
export function checkMap(id) {
    const folderName = PATH_MAPS + id;
    const fileName = MAP_NAME;
    return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory + folderName, function (fs: DirectoryEntry) {
            const reader = fs.createReader();
            reader.readEntries(
                function (entries) {
                    const find = entries.find(element => element.isFile && element.name === fileName);
                    if (find) {
                        resolve({ id, value: true });
                    } else {
                        resolve({ id, value: false });
                    }
                },
                function (err) {
                    resolve({ id, value: false });
                }
            );
        }, (onErrorFs) => {
            resolve({ id, value: false });
        });
    });
}
/**
 * Restituisce la lista delle cartelle delle mappe create in precedenza
 * @returns {Promise} con la lista delle mappe nella funzione resolve della promise
 */
export function listMaps() {
    return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory + PATH_MAPS, function (fs: DirectoryEntry) {
            const reader = fs.createReader();
            reader.readEntries((entries) => {
                const findMap = [];
                entries.filter(element => {
                    if (element.isDirectory) {
                        findMap.push(element.name);
                    }
                });
                resolve(findMap);
            },
                function (err) {
                    reject(err);
                }
            );
        }, (onErrorFs) => {
            reject(onErrorFs);
        });
    });
}
/**
 * Apre l'indirizzo in una nuova webview
 * @param URL l'indirizzo da aprire/raggiungere
 */
export function openFile(URL) {
    cordova.InAppBrowser.open(URL, '_blank', 'location=no');
}
/**
 * Converte un {File} in un oggetto {Blob}
 * @param file da convertire in blob
 * @returns {Blob}
 */
function convertFileToBlob(file) {
    return new Blob([file], { type: file.type });
}
/**
 * Restituisce l'estensione del file passatogli
 * @param value nome del file
 * @returns {String} estensione del file parsificato
 */
export function typeFile(value: string) {
    if (value.match(/\.(jpg)$/)) {
        return '.jpg';
    } else if (value.match(/\.(jpeg)$/)) {
        return '.jpeg';
    } else if (value.match(/\.(png)$/)) {
        return '.png';
    } else if (value.match(/\.(JPG)$/)) {
        return '.JPG';
    } else if (value.match(/\.(JPEG)$/)) {
        return '.JPEG';
    } else if (value.match(/\.(PNG)$/)) {
        return '.PNG';
    }
}
